const strings = {
  title: 'Quantas pessoas trabalham atualmente na sua empresa?',
  accordionDescription:
    'Para definir a mensalidade, precisamos saber quantos funcionários terão o plano de saúde.',
  submitLabel: 'Continuar'
}

export { strings }
